import {combineReducers} from 'redux';
import auth from './auth';
import toast from './toast';
import remoteConfig from './remoteConfig';
export default combineReducers({
	auth,
	toast,
	remoteConfig,
});
